import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PBService } from '../pocketbase.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(private pb: PBService, private router: Router) {}

  async login(email: string, password: string): Promise<void> {
    try {
      await this.pb.login(email, password);
      await this.router.navigate(['/menus']);
      window.location.reload();
    } catch (error) {
      throw new Error('Authentication failed');
    }
  }

  isAuthenticated() {
    return this.pb.isAuthenticated();
  }

  logout(): void {
    this.pb.client.authStore.clear();
    localStorage.removeItem('pb_auth');
    window.location.reload();
  }
}
